import { render } from "./RightSectors.vue?vue&type=template&id=4181fbbe&scoped=true"
import script from "./RightSectors.vue?vue&type=script&lang=js"
export * from "./RightSectors.vue?vue&type=script&lang=js"

import "./RightSectors.vue?vue&type=style&index=0&id=4181fbbe&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NfzNB5gn/0/softbot/chatbot/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4181fbbe"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QIcon,QBtn,QTabs,QTab,QTabPanels,QTabPanel,QScrollArea,QBadge});
